let initialState = null;

function notification_signature(state = initialState, action) {
    if (action.type === "GET_NOTIFICATION_SIGNATURES") {
        return action.res;
    } else return state;
}

export default notification_signature;
